module.exports = __webpack_public_path__ + "img/Bildschirmfoto_2022-02-10_um_18.41.10.7e36b36d.png";